import PropTypes from 'prop-types';

export default PropTypes.shape({
  variantName: PropTypes.string,
  brandName: PropTypes.string,
  drugName: PropTypes.string,
  brandDesc: PropTypes.string,
  prodDesc: PropTypes.string.isRequired,
  form: PropTypes.string.isRequired,
  vmpId: PropTypes.string.isRequired,
  nd: PropTypes.bool,
  isMCS: PropTypes.bool,
  status: PropTypes.string,
  itemExemption: PropTypes.string,
});

export const medicinesForms = PropTypes.shape({
  branded: PropTypes.bool,
  vtmId: PropTypes.string,
  name: PropTypes.string,
  forms: PropTypes.object,
});
